import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';

export const DemoBanner = () => {
  const location = useLocation();
  const { user, loading, demoViewMode, setDemoViewMode } = useAuth();
  if (!DEMO_MODE) return null;
  if (loading) return null;
  if (['/login', '/register', '/pricing', '/landing'].includes(location.pathname)) return null;
  if (location.pathname.startsWith('/portal/')) return null;
  if (location.pathname === '/' && !user) return null;
  if (location.pathname.startsWith('/dev-hub')) return null;
  if (user?.is_platform_operator) return null;
  const DEMO_EMAILS = ['demo@allaboutclaims.com', 'demo-provider@allaboutclaims.com'];
  if (user?.email && !DEMO_EMAILS.includes(user.email)) return null;

  const currentMode = demoViewMode || user?.account_type || 'solo';
  const otherMode = currentMode === 'solo' ? 'provider' : 'solo';
  const modeLabel = currentMode === 'solo' ? 'Solo' : 'Provider';
  const otherLabel = otherMode === 'solo' ? 'Solo' : 'Provider';
  const modeColor = currentMode === 'solo' ? 'bg-teal-600' : 'bg-blue-600';
  const switchColor = otherMode === 'solo' ? 'text-teal-100 hover:text-white' : 'text-blue-100 hover:text-white';

  return (
    <div className="flex justify-center z-[60] relative">
      <div className={`${modeColor} text-white text-center py-1 px-3 md:px-6 text-[10px] md:text-xs font-medium rounded-b-md flex items-center gap-2 md:gap-3 transition-colors duration-300`} data-testid="demo-banner">
        <span className="opacity-80 hidden sm:inline">Viewing:</span>
        <span className="font-bold" data-testid="demo-mode-label">{modeLabel} Demo</span>
        <button
          onClick={() => setDemoViewMode(otherMode)}
          className={`inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 transition-colors rounded px-2 py-0.5 text-xs font-semibold ${switchColor}`}
          data-testid="demo-mode-switch"
        >
          Switch to {otherLabel}
        </button>
        <span className="hidden sm:inline opacity-40">|</span>
        <Link to="/pricing" className="inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 transition-colors rounded px-2 py-0.5 text-xs font-semibold text-white" data-testid="demo-banner-signup-cta">
          Sign Up &rarr;
        </Link>
      </div>
    </div>
  );
};

export const isDemoMode = () => DEMO_MODE;

export const DEMO_CREDENTIALS = {
  email: 'demo@allaboutclaims.com',
  password: 'demo2026',
};
